import { render, staticRenderFns } from "./OrmMessageListView.vue?vue&type=template&id=610d4c96"
import script from "./OrmMessageListView.vue?vue&type=script&lang=js"
export * from "./OrmMessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports